$(document).ready(function () {
    $("#table-sections").DataTable({
        responsive: true,
        ajax: '/admin/get-sections',
        proccesing: true,
        serverSide: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
        columns: [
            {data: 'id', name: 'id'},
            {data: 'description', name: 'description'},
            {data: 'numItems', name: 'numItems'},
            {data: 'countrys', name: 'countrys'},
        ],
        "columnDefs": [{
            "targets": 4,
            "data": "download_link",
            "render": function (data, type, row, meta) {
                let button = getButton(row.status, row.id)
                let status = get_global_status(row.status);
                return '<button data-toggle="tooltip" data-placement="top" title="Editar" class="btn button_almadia_reverse ' +
                    'edit-section btn-sm"' +
                    'data-data ="' + row + '"><i class="far fa-edit"></i></button> ' +

                    '<a href="'+ '/admin/detalles-seccion/'+row.slug +  '" data-toggle="tooltip" data-placement="top" ' +
                    'class="btn button_almadia btn-sm" title="Visualizar libros en la sección">' +
                    '<i class="fa-solid fa-list"></i>'  +

                    '<a href="#" data-toggle="tooltip" data-placement="top" title="' + status.title + '" ' +
                    'class="btn btn-' + status.color_clas + ' change-sections-status btn-sm m-1"  ' +
                    'data-slug_section ="' + row.slug + '"><span class="' + status.icon + '"></span></a> ' +
                    button

            }
        }]
    });

    let list_sections_table = $("#table-sections").DataTable();

    $("#new-section").on('click', function () {
        $(".modal-title").text('Agregar sección')
        $("#modal-sections").modal('show');
        $(".item-id").val('')
        $(".item-description").val('')
        addOptionToSelectChoise('select-countrys', '')
        addOptionToSelectChoise('select-visible', '')
    })

    $("#table-sections tbody").on('click', '.edit-section', function (e) {
        e.preventDefault()
        $(".modal-title").text('Editar sección')
        rowData = list_sections_table.row($(this).parents('tr')).data()
        $.each(rowData, function (index, value) {
            $(".item-" + index).val(value)
            if (index === "countrys") addOptionToSelectChoise('select-countrys', value)
            if (index === "visible") addOptionToSelectChoise('select-visible', value)
        })
        $("#modal-sections").modal('show');
    })

    $("#table-sections tbody").on('click','.delete-section',function (e){
        let data = new FormData()
        data.append('id',$(this).data('id'))
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                sendData(data,'/admin/delete-section','modal-sections')
            }
        })

    })

    $("#table-sections tbody").on('click', '.add-detail', function (e) {
        e.preventDefault()
        let slug = $(this).data('slug')
        $(".item-id").val(slug)
        $(".title-modal-add-detail").text('Agregar libro')
        $("#modal-add-detail").modal('show')
    })

    $("#form-sections").on('submit', function (e) {
        e.preventDefault()
        $(".loader_").addClass("loading")
        let data = new FormData(this)
        sendData(data, '/admin/send-section', 'modal-sections')
        $(".loader_").addClass("loading")
    })

    $("#add-book-secction").on('click', function (e) {
        e.preventDefault()
        let slug = $('.item-search-id').val()
        let slug_section = $('.item-id').val()
        let data = new FormData()
        data.append('slug', slug)
        data.append('slug_section', slug_section)
        $(".loader_").addClass("loading")
        sendData(data, '/admin/add-book-to-detail', 'modal-add-detail')
    })

    $("#table-sections tbody").on('click','.change-sections-status', function (e){
        e.preventDefault()
        let data = new FormData()
        data.append('slug',$(this).data('slug_section'))
        sendData(data,'/admin/update-sections-status')
    })


    function sendData(data, route, modal) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route,
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (data.type == "success") {
                        console.log("Aqui")
                        alertSuccess(data.msg)
                        $("#table-sections").DataTable().ajax.reload();
                        $("#" + modal).modal("hide")
                        return true
                    }
                    if (data.type == "success_add_book_section") {
                        location.reload()
                    } else {
                        alertError(data.msg)
                    }
                }, 1000)

                console.log("Aqui4")
            },
            error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }

    function addOptionToSelectChoise(classe, value) {
        $('.'+ classe).val(value)
        $('.'+ classe).trigger("chosen:updated")
    }

    function getButton(status,id) {
        if (status == "D") {
            return '<button data-toggle="tooltip" data-placement="top" title="Elimimar"' +
                'class="btn btn-danger delete-section btn-sm" data-id ="' + id + '" >' +
                '<i class="fa-solid fa-trash-can-arrow-up"></i>' +
                '</button> '
        }
        return "";
    }


})
